/**
 * A TELA ABERTA, do jeito que o Lumos entende (Fase 1, 08/10/2026).
 *
 * "Resume este processo" só funciona se o Lumos souber qual. A bolha manda
 * `{ tipo, id }` junto da pergunta; o servidor confere que o registro é da
 * conta (Captain::Copilot::ChatService#tela_atual). Uma função só, usada
 * pela bolha (o que enviar) e pela tela vazia (que sugestões oferecer).
 *
 * @param {{ name?: string, params?: object }} rota
 * @returns {{ tipo: 'processo'|'contato', id: string } | null}
 */
const TELAS = {
  legal_process_show: { tipo: 'processo', param: 'processId' },
  contacts_edit: { tipo: 'contato', param: 'contactId' },
};

export const telaAberta = rota => {
  const tela = TELAS[rota?.name];
  const id = tela && rota.params?.[tela.param];
  return id ? { tipo: tela.tipo, id: String(id) } : null;
};
